import * as React from 'react';
import PropTypes from 'prop-types';
import { useSession } from '@hooks';

type LeasesAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_area_leases_title", //Baux
]

const LeasesArea: React.FC<LeasesAreaProps> = () => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_area_leases_title")}</span>
  </div>;
};

LeasesArea.propTypes = {
  //
};

export default LeasesArea;
